import * as yup from 'yup';
import * as utils from './utils';
import { Contact } from '../entities';

export const schemaContact = yup.object<Partial<Contact>>({
    nom: yup.string().required('Ce champ est requis'),
    prenom: yup.string().nullable(),
    created_at: utils.toStringSchema(yup.date().nullable().transform(utils.emptyStringToNullTransform)),
    email: yup.string().email('Ce champ doit contenir une adresse courriel valide').required('Ce champ est requis'),
    isAdmin: yup.boolean().nullable().default(false).transform(utils.nullBoolToFalse),
    updatePassword: yup.boolean().nullable().default(false).transform(utils.nullBoolToFalse),
    password_hash: yup.string().nullable(),
    telephone: yup.string().required('Ce champ est requis'),
    notes: yup.string().nullable(),
    actif: yup.boolean().nullable().default(true).transform(utils.nullBoolToFalse),
}) as yup.ObjectSchema<Partial<Contact>>;
